import {Backup} from "@/backup/Backup.ts";

const createdAtFormatter = new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
});

export function formatBackupDisplayName(backup: Backup): string {
    return `DireDawn · ${createdAtFormatter.format(backup.createdAt)}`;
}
